// The instrument tags a clip can have: a category, then a type within it. "Full mix" and "Other"
// have no types; "Other" takes a free-text description as its type.
export const INSTRUMENTS = {
  Drums: ['Kick', 'Snare', 'Hi-hat', 'Toms', 'Cymbals', 'Percussion', 'Full kit'],
  Bass: ['Sub bass', 'Electric bass', 'Synth bass', '808'],
  Keys: ['Piano', 'Electric piano', 'Organ', 'Pad'],
  Guitar: ['Acoustic', 'Electric clean', 'Electric distorted'],
  Synth: ['Lead', 'Pad', 'Pluck', 'Arp'],
  Vocals: ['Lead', 'Backing', 'Harmony', 'Ad-libs'],
  FX: ['Riser', 'Impact', 'Ambience'],
  'Full mix': [],
  Other: [],
};

export const CATEGORIES = Object.keys(INSTRUMENTS);
export const FULL_MIX = 'Full mix';
export const OTHER = 'Other';

export const DAW_OPTIONS = [
  'Ableton Live', 'FL Studio', 'Logic Pro', 'Pro Tools', 'Cubase', 'Studio One', 'Reaper', 'Bitwig Studio',
  'GarageBand', 'General / Other',
];

// Filename patterns, most specific first; mix words come last so "kick_final.wav" is still a kick
const GUESSES = [
  [/\bkick/, 'Drums', 'Kick'],
  [/\bsnare/, 'Drums', 'Snare'],
  [/\bhi ?hats?\b|\bhats?\b/, 'Drums', 'Hi-hat'],
  [/\btoms?\b/, 'Drums', 'Toms'],
  [/\bcymbals?|\bcrash|\bride\b/, 'Drums', 'Cymbals'],
  [/\bperc|\bshaker|\bclap|\bconga|\bbongo/, 'Drums', 'Percussion'],
  [/\bdrums?\b|\bkit\b/, 'Drums', 'Full kit'],
  [/808/, 'Bass', '808'],
  [/\bsub\b|\bsub ?bass/, 'Bass', 'Sub bass'],
  [/\bsynth ?bass/, 'Bass', 'Synth bass'],
  [/\bbass/, 'Bass', 'Electric bass'],
  [/\bbacking|\bbvs?\b|\bbgvs?\b/, 'Vocals', 'Backing'],
  [/\bharmon/, 'Vocals', 'Harmony'],
  [/\bad ?libs?/, 'Vocals', 'Ad-libs'],
  [/\bvox\b|\bvocals?|\bvoc\b/, 'Vocals', 'Lead'],
  [/\brhodes|\bwurli|\be ?piano|\belectric piano/, 'Keys', 'Electric piano'],
  [/\bpiano/, 'Keys', 'Piano'],
  [/\borgan/, 'Keys', 'Organ'],
  [/\bacoustic/, 'Guitar', 'Acoustic'],
  [/\bdist|\bcrunch/, 'Guitar', 'Electric distorted'],
  [/\bguitars?|\bgtr/, 'Guitar', 'Electric clean'],
  [/\bpads?\b/, 'Synth', 'Pad'],
  [/\bpluck/, 'Synth', 'Pluck'],
  [/\barp/, 'Synth', 'Arp'],
  [/\blead\b|\bsynth/, 'Synth', 'Lead'],
  [/\briser|\bsweep|\buplifter/, 'FX', 'Riser'],
  [/\bimpact|\bdownlifter/, 'FX', 'Impact'],
  [/\bambien|\batmos|\bfx\b/, 'FX', 'Ambience'],
  [/\bmix\b|\bmixdown|\bmaster|\bbounce|\bfinal\b|\bfull\b/, FULL_MIX, null],
];

/** The instrument a file name suggests, as { category, type }, or null when it says nothing useful */
export const guessInstrument = (filename = '') => {
  const words = ` ${filename.replace(/\.[a-z0-9]+$/i, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ')} `;
  const match = GUESSES.find(([pattern]) => pattern.test(words));
  return match ? { category: match[1], type: match[2] } : null;
};

// Types that read better with their category after them: "Lead vocal", "Lead synth", "Acoustic guitar"
const NAME_SUFFIX = { Vocals: 'vocal', Synth: 'synth', Guitar: 'guitar' };

/** A clip name to start from: "Kick", "Lead vocal", "Full mix", or what an "Other" clip was called */
export const suggestClipName = ({ category, type }) => {
  if (!category) return '';
  if (category === FULL_MIX) return FULL_MIX;
  if (type && NAME_SUFFIX[category]) return `${type} ${NAME_SUFFIX[category]}`;
  return type || category;
};
